export const bodyPhotoKeys = {
    all: ['bodyPhotos'] as const,
    member: (centerId: string, memberId: string) => [...bodyPhotoKeys.all, centerId, memberId] as const,
};
